import { Base64 } from 'js-base64';

import type { AnalyticsEvent } from '../types';

const insertEventIf = <T extends AnalyticsEvent>(
  ifCondition: boolean,
  event: T,
): T[] => (ifCondition ? [event] : []);

const decodeQuestionId = (questionId: string): string => {
  try {
    const decodedString = Base64.decode(questionId)
      .split(',')
      .map((x) => {
        const [key, value] = x.split(':');
        return {
          [key]: value,
        };
      })
      .find((x) => x.gid !== null);

    if (decodedString === undefined || decodedString.gid === undefined) {
      throw new Error('Could not find gid field in base64 question ID.');
    }

    return decodedString.gid;
  } catch (e) {
    return questionId;
  }
};

export { insertEventIf, decodeQuestionId };
